import script from "./friendly-news-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./friendly-news-list.vue?vue&type=script&setup=true&lang=ts"

import "./friendly-news-list.vue?vue&type=style&index=0&id=5ea6ba46&lang=scss&scoped=true"

import exportComponent from "D:\\work\\kaifengzimaoqu\\wt_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ea6ba46"]])

export default __exports__